module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Get with the Program","short_name":"Get with the Program","start_url":"/","background_color":"#fff","theme_color":"#37A7DF","display":"standalone","icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"6f4d89c3d638d47cd356ee070f443f57"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
